import { FormItemTypeDTO, FormFieldsGroupResponseDTO } from '@/api/base/DTOs';
import { IFormBase } from '@/forms/typings';
import { formApiAdapterRegistry, type FormItemAdapterFunction } from './form-api-adapter.registry';
import {
  adaptFormFieldsGroupResponseToArrayFormField,
  adaptFormItemResponseToFieldsGroup,
} from '../groups';
import {
  adaptFormDateRangeFieldsResponseToDateRangeFormField,
  adaptFormFileFieldResponseToFileFormField,
  adaptFormOfficeHoursFieldResponseToOfficeHoursFormField,
  adaptFormQuestionWithDetailsFieldResponseToQuestionWithDetailsFormField,
  adaptFormInferredFieldResponseToSingleFormField,
} from '../field-types';
import { adaptFormFieldResponseToSingleFormField } from '../single-field';
import {
  adaptFormStagedFieldsGroupResponseToStagedFieldsGroupFormField,
  adaptFormConditionalFieldsGroupResponseToConditionalFieldsGroupFormField,
} from '../groups';

/**
 * Special adapter for FieldsGroup that handles both single and multiple (array) cases
 */
const adaptFieldsGroup = (
  item: FormFieldsGroupResponseDTO,
  parentFieldId?: IFormBase['fieldId'],
) => {
  return item.isMultiple
    ? adaptFormFieldsGroupResponseToArrayFormField(item, parentFieldId)
    : adaptFormItemResponseToFieldsGroup(item, parentFieldId);
};

/**
 * Register all API form adapters on {@link formApiAdapterRegistry} (Registry 1).
 */
function initializeFormApiAdapterRegistry() {
  formApiAdapterRegistry
    .register(
      FormItemTypeDTO.FieldsGroup,
      adaptFieldsGroup as FormItemAdapterFunction,
    )
    .register(
      FormItemTypeDTO.DateRangeFields,
      adaptFormDateRangeFieldsResponseToDateRangeFormField as FormItemAdapterFunction,
    )
    .register(
      FormItemTypeDTO.QuestionWithDetails,
      adaptFormQuestionWithDetailsFieldResponseToQuestionWithDetailsFormField as FormItemAdapterFunction,
    )
    .register(
      FormItemTypeDTO.OfficeHours,
      adaptFormOfficeHoursFieldResponseToOfficeHoursFormField as FormItemAdapterFunction,
    )
    .register(
      FormItemTypeDTO.StagedFieldsGroup,
      adaptFormStagedFieldsGroupResponseToStagedFieldsGroupFormField as FormItemAdapterFunction,
    )
    .register(
      FormItemTypeDTO.Field,
      adaptFormFieldResponseToSingleFormField as FormItemAdapterFunction,
    )
    .register(
      FormItemTypeDTO.InferredField,
      adaptFormInferredFieldResponseToSingleFormField as FormItemAdapterFunction,
    )
    .register(
      FormItemTypeDTO.File,
      adaptFormFileFieldResponseToFileFormField as FormItemAdapterFunction,
    )
    .register(
      FormItemTypeDTO.ConditionalFieldsGroup,
      adaptFormConditionalFieldsGroupResponseToConditionalFieldsGroupFormField as FormItemAdapterFunction,
    );
}

initializeFormApiAdapterRegistry();
